import $ from 'jquery';
import { filter_select_fields } from './integrations';

export function connection_setup_filtering() {
  const form = document.querySelector("form.new_connection_setup, form.edit_connection_setup");
  if (!form) {
    return;
  }

  const isNewConnectionSetup = form.classList.contains("new_connection_setup");
  const select_field = document.getElementById("connection_setup_integration_type");
  let type_classes = [].slice.call(select_field).map((select) => `.${select.value}`);

  if (!isNewConnectionSetup) {
    type_classes = [
      ".entrata",
      ".greystar",
      ".real_page",
      ".rent_manager",
      ".local_csv",
      ".remote_csv",
      ".app_folio",
      ".yardi",
      ".buildium",
      ".res_man",
      ".mri",
      ".fsr",
      ".vantaca",
    ];
  }

  $.each(type_classes, (index, value) => {
    type_classes.push(`${value}_autopopulated`);
  });

  buildConnectionSetupTypeForm(select_field, type_classes);

  if (isNewConnectionSetup) {
    select_field.addEventListener("change", () => {
      buildConnectionSetupTypeForm(select_field, type_classes);
      const selected_type_class = getSelectedTypeClass(select_field);
      hideAutoPopulated(selected_type_class);
    });
  }
}

export async function add_event_listener_cs() {
  while (!document.querySelector("#integration_form_connection_setup_id")) {
    await new Promise(r => setTimeout(r, 50));
  }

  const select_field = document.getElementById("integration_form_connection_setup_id");
  select_field.addEventListener("change", filter_select_fields);
  filter_select_fields();
}

function buildConnectionSetupTypeForm(select_field, type_classes) {
  const selected_type_class = getSelectedTypeClass(select_field);
  const filtered_type_classes = getFilteredTypeClasses(type_classes, selected_type_class);
  updatePlaceholderText();
  hideFieldsNotContainingClass(filtered_type_classes, selected_type_class);
  showFieldsContainingClass(selected_type_class);
  if (!/new/.test(window.location.href)) { showFieldsContainingClass(`${selected_type_class}_autopopulated`); }
}

// This function converts integration type names like "Real Page" to "real_page"
// so they can be used to render fields relevant to that integration type
function getSelectedTypeClass(select_field) {
  const withUnderscores = select_field.value.replace(/([a-z])([A-Z])/g, '$1_$2');
  return `.${withUnderscores.replace(/ /g, '_').toLowerCase()}`;
}

function getFilteredTypeClasses(type_classes, selected_type_class) {
  return type_classes.filter((current_class, index, arr) => (current_class !== selected_type_class) && (current_class !== (`${selected_type_class}_autopopulated`)));
}

function hideAutoPopulated(target_class) {
  $(`${target_class}_autopopulated`).each(function () {
    $(this).prop("disabled", true);
    $(this).hide();
    $(`label[for='${$(this).attr("id")}']`).parent(0).hide();
  });
}

function hideFieldsNotContainingClass(all_classes, target_class) {
  $(all_classes.join(",")).each(function () {
    if (!$(this).hasClass(target_class)) {
      $(this).prop("disabled", true);
      $(this).hide();
      $(`label[for='${$(this).attr("id")}']`).parent(0).hide();
    }
  });
}

function showFieldsContainingClass(target_class) {
  $(target_class).each(function () {
    $(this).prop("disabled", false);
    $(this).show();
    $(`label[for='${$(this).attr("id")}']`).parent(0).show();
  });
}

function updatePlaceholderText() {
  const integration_type = document.getElementById("connection_setup_integration_type").value;
  let placeholder;

  switch (integration_type) {
    case "remote_csv":
      placeholder = "e.g. eft.avalonbay.com";
      break;
    case "entrata":
      placeholder = "e.g. entrata.subdomain.com";
      break;
    case "rent_manager":
      placeholder = "e.g. subdomain.api.rentmanager.com";
      break;
    case "app_folio":
      placeholder = "e.g. subdomain.appfolio.com";
      break;
    case "yardi":
      placeholder = "e.g. www.yardiasp13.com/subdomain";
      break;
    case "mri":
      placeholder = "e.g. subdomain.partners.mrisoftware.com";
      break;
    default:
      placeholder = "e.g. entrata.subdomain.com";
  }
  const host = document.getElementById("connection_setup_host");
  host.setAttribute("placeholder", placeholder);
}
